// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"abe8545f","388":"90fe78bd","733":"bfac0556"}[chunkId] + ".chunk.js";
};